/**
 * One timing for everything a list row opens and closes — its positions, its outcome
 * lines — so two accordions on the same row never run at different speeds.
 *
 * Eased out, not in-out: an accordion is a direct answer to a click, so it leaves at
 * once and settles at the end rather than easing away from the pointer first.
 */
export const ACCORDION_MOTION = { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
